import type { AllRouteEndpoints } from "../routeTypes";
export const engagementLinkTemplatesUpdateTagsCacheKeys: AllRouteEndpoints[] = ["/engagement/v2/link_templates"];
